import React from 'react'
import PropTypes from 'prop-types'
import Path from '@leverege/path'
import { connect } from 'react-redux'

import { EventActions, BlueprintActions, BreadcrumbActions, DeviceActions, SystemActions } from '../../actions'
import QueryScreen from './QueryScreen'

class DeviceEventScreen extends React.Component {

  componentDidMount() {
    const { dispatch, match : { params : { deviceId, systemId } } } = this.props

    dispatch( DeviceActions.getDevice( systemId, deviceId ) )
    dispatch( SystemActions.get( systemId ) )
  }

  componentDidUpdate( prevProps, prevState ) {
    // TODO : move out to device/system/project history page
    // get blueprint if we need it
    const { dispatch, match : { params : { deviceId, projectId, systemId, blueprintId } }, devices, blueprint, systems } = this.props
    const { oldDevices } = prevProps

    if ( Path( [ 'lookup', deviceId ] ).get( devices, null ) && 
         !Path( [ 'lookup', deviceId ] ).get( oldDevices, null ) && 
        ( blueprint && blueprint.data && blueprint.data.id ) !== Path( [ 'lookup', deviceId, 'blueprintId' ] ).get( devices, null ) ) {
      dispatch( BlueprintActions.getBlueprint( projectId, Path( [ 'lookup', deviceId, 'blueprintId' ] ).get( devices, null ) ) )
    }

    const sName = Path( [ 'lookup', systemId, 'name' ] ).get( systems, null )
    const dName = Path( [ 'lookup', deviceId, 'name' ] ).get( devices, null )
    const bName = Path( 'data/name' ).get( blueprint, null )
    
    if ( blueprintId ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${projectId}/system` }, 
          { name : sName || systemId, link : `/project/${projectId}/system/${systemId}/device` },
          { name : bName || blueprintId, link : `/project/${projectId}/system/${systemId}/blueprint/${blueprintId}/device` },
          { name : dName || deviceId } ] ) )
    } else {
      dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Systems', link : `/project/${projectId}/system` }, 
          { name : sName || systemId, link : `/project/${projectId}/system/${systemId}/device` },
          { name : dName || deviceId } ] ) )
    }
  }

  getResultsDisplayers = ( query, results ) => {
    if ( query && query.paths && query.paths.length > 1 ) {
      return [ 'table', 'blob' ]
    }
    return [ 'blob' ]
  }

  render() {
    const { match : { params : { deviceId } }, location, history, blueprint, events } = this.props

    return (
      <QueryScreen events={events} title="Device Events" actions={EventActions} location={location} history={history} queryName="defaultDevice" queryType="device" queryable={deviceId} resultsDisplayers={this.getResultsDisplayers} />
    )
  }
}

export default connect(
  state => ( {
    systems : state.systems,
    devices : state.devices,
    blueprint : state.blueprint,
    events : state.events
  } )
)( DeviceEventScreen )
